<template>
  <div class="tag-bg d-flex align-items-center" :style="{backgroundColor: getCategoryColor(this.text)}" >
    <div v-bind:class="[small ? 'tag-text-small' : 'tag-text']">{{ text }}</div>
  </div>
</template>

<script>
import CategoryColor from "@/mixins/CategoryColor";

export default {
name: "Tag",
  props:{
    text:{
      type: String,
      default: "Tag"
    },
    color:{
      type: String,
      default: "#42b983"
    },
    small:{
      type: Boolean,
      default: false
    }
  },
  mixins:[CategoryColor]
}
</script>

<style scoped>


.tag-bg{
  background-color: #42b983;
  height: 25px;
  margin-right: 5px;
  border-radius: 26px;
  margin-top: 3px;
}

.tag-text{
  padding: 10px 15px;
  color: white;
  white-space: nowrap;
}

.tag-text-small{
  padding: 4px 12px;
  color: white;
  white-space: nowrap;
  font-size: 0.8rem;
}

</style>